import { createApp } from 'vue'
import App from './App.vue'

// Wait for DOM to be ready before mounting
const mountApp = () => {
  console.log('🚀 Vue Course View - Attempting to mount...')
  const appElement = document.getElementById('app')

  if (!appElement) {
    console.error('❌ #app element not found!')
    return
  }

  console.log('✅ #app element found, creating Vue app...')
  const app = createApp(App)
  app.mount('#app')
  console.log('✅ Vue Course View App mounted successfully!')
}

if (document.readyState === 'loading') {
  console.log('⏳ Waiting for DOM...')
  document.addEventListener('DOMContentLoaded', mountApp)
} else {
  console.log('✅ DOM already loaded')
  mountApp()
}
